import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LanguageIcon from '@mui/icons-material/Language';
import GroupIcon from '@mui/icons-material/Groups';
import PaymentsIcon from '@mui/icons-material/Payments';

const StatCard = ({ number, label, icon }) => {
    const [count, setCount] = useState(0);
    const theme = useTheme();

    useEffect(() => {
        let start = 0;
        const end = parseInt(number, 10);
        if (start === end) return;

        let totalDuration = 2000;
        let incrementTime = (totalDuration / end) * 10;

        let timer = setInterval(() => {
            start += 1;
            setCount(start);
            if (start === end) clearInterval(timer);
        }, incrementTime);

        return () => clearInterval(timer);
    }, [number]);

    return (
        <Paper
            elevation={3}
            sx={{
                p: 3,
                textAlign: 'center',
                background: 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.01) 100%)',
                backdropFilter: 'blur(10px)',
                border: `1px solid rgba(255, 215, 0, 0.3)`,
                borderRadius: '20px',
                transition: 'transform 0.3s',
                '&:hover': {
                    transform: 'translateY(-10px)',
                    borderColor: theme.palette.secondary.main,
                    boxShadow: `0 0 30px rgba(255, 215, 0, 0.2)`
                }
            }}
        >
            <Box sx={{ color: theme.palette.secondary.main, mb: 1 }}>
                {icon}
            </Box>
            <Typography variant="h3" sx={{ color: theme.palette.secondary.main, fontWeight: 'bold' }}>
                {count}+
            </Typography>
            <Typography variant="body1" sx={{ color: '#fff', textTransform: 'uppercase', letterSpacing: '2px', mt: 1 }}>
                {label}
            </Typography>
        </Paper>
    );
};

const Stats = () => {
    return (
        <Box sx={{ py: 4, px: 2 }}>
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12} sm={4}>
                    <StatCard number={30} label="Active Sites" icon={<LanguageIcon fontSize="large" />} />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <StatCard number={1580} label="Happy Members" icon={<GroupIcon fontSize="large" />} />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <StatCard number={2470} label="Withdrawals" icon={<PaymentsIcon fontSize="large" />} />
                </Grid>
            </Grid>
        </Box>
    );
};

export default Stats;
